<comment>
グレードリスト カルーセル部分
状態変化時、開始点と終点のフラグ（ページャーボタンのdisabled制御用）を引数にpageStateChangeをemit
外部コンポーネントからはnext、prevメソッドでカルーセルを操作
</comment>

<template>
  <div class="gradeslider-viewport" ref="viewport">
    <div class="gradeslider-core" ref="core">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'gradeSlider',
  data: function(){
    return {
      page: 0,
      viewportWidth: 0,
      pos: [0]//ページごとのカルーセル座標（ネガティブmarginLeft）を保持
    };
  },
  watch: {
    page: function(){
      this.emitState();
    },
    viewportWidth: function(){
      this.updateState();
    }
  },
  methods:{
    emitState: function(){
      this.$emit('pageStateChange',this.page <= 0,this.page >= this.pos.length-1);
    },
    next: function(){
      if(this.page >= this.pos.length-1){//終端
        return;
      }
      this.page++;
      this.$refs.core.style.marginLeft = -1*this.pos[this.page]+'px';
    },
    prev: function(){
      if(this.page <= 0){//開始地点
        return;
      }
      this.page--;
      this.$refs.core.style.marginLeft = -1*this.pos[this.page]+'px';
    },
    updateState: function(){
      this.viewportWidth = this.$refs.viewport.clientWidth;
      const newPos = [0];
      let total = 0;
      var children = Array.prototype.slice.call(this.$refs.core.childNodes,0);//IE11
      children.forEach(element => {
        const w = element.clientWidth;
        if(total + w <= this.viewportWidth){
          total += w;
        }else{
          newPos.push(newPos[newPos.length-1]+total);
          total = w;
        }
      });
      this.pos = newPos;
      this.emitState();
    },
    resized: function(){
      const prevViewport = this.viewportWidth;
      this.updateState();
      if(prevViewport !== this.viewportWidth){
        //リサイズ対応 アニメーションなしでスライドを0にもどす
        this.$refs.core.style.transition = 'none';
        this.page = 0;//nextPage;
        this.$refs.core.style.marginLeft = 0+'px';
        setTimeout(()=>{
          this.$refs.core.style.transition = '';
        });
      }
    },
  },
  created:function(){
    this.$on('next', this.next);
    this.$on('prev', this.prev);
    this.$on('updateState', this.updateState);
  },
  mounted:function(){
    this.updateState();
    //リサイズ対応
    window.addEventListener('resize',this.resized);
  },
  beforeDestroy:function(){
    //リサイズ対応
    window.removeEventListener('resize',this.resized);
  },
  updated:function(){
    this.updateState();
  }
}
</script>

<style scoped lang="scss">
.gradeslider-viewport{
  width: 100%;
  position: relative;
  overflow: hidden;
}
.gradeslider-core{
  display: flex;
  left: 0;
  top: 0;
  transition: 0.5s margin;
}
</style>
